<app-therapist-header></app-therapist-header>

<section class="therapist-module-outer">
  <div class="therapist-title-block">
    <h1 class="therapist-title-block__title">My Availability</h1>

    <div class="therapist-title-block__right-block">
      <button class="btn btn--primary" [routerLink]="['/therapist/my-appointments-new']">
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.6111 1.40283L1 4.90109L4.6111 8.39935" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M1 4.90106L6.77777 4.90106C10.7666 4.90106 14 8.0334 14 11.8976V12.5972"
            stroke="#ffffff"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        My Appointments
      </button>
    </div>

    <div class="therapist-title-block__calendra-next-prev">
      <div class="calendra-prev-arrow" mwlCalendarPreviousView view="month" [(viewDate)]="viewDate" (click)="dateChange()">
        <i class="arrow-prev"></i>
      </div>
      <div class="btn btn--primary" mwlCalendarToday [(viewDate)]="viewDate" (click)="dateChange()">Today</div>
      <div class="calendra-next-arrow" mwlCalendarNextView view="month" [(viewDate)]="viewDate" (click)="dateChange()">
        <i class="arrow-next"></i>
      </div>

      <div class="calendar-day">
        {{ viewDate | calendarDate : 'monthViewTitle' : 'en' }}
      </div>
    </div>
  </div>

  <div class="therapist-content-block">
    <div class="view-by-available-slots">
      <div class="view-by-available-slots__scroll day-view">
        <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [cellTemplate]="monthCellTemplate"> </mwl-calendar-month-view>
      </div>
    </div>

    <div class="loader-block" *ngIf="loadingCustom">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
    </div>
  </div>
</section>

<ng-template #monthCellTemplate let-day="day" let-locale="locale">
  <div class="cal-cell-top">
    <span class="cal-day-number">{{ day.date | calendarDate : 'monthViewDayNumber' : locale }}</span>
  </div>

  <div class="available-slots_event" *ngFor="let item of day.events">
    <small *ngIf="item.isHoliday && item.isFullDay && !item.isGlobalHoliday" [ngClass]="getEventClass(item)" pTooltip="{{ item.title1 }}">
      {{ item.title }}
    </small>

    <small
      *ngIf="item.isHoliday && !item.isFullDay && !item.isGlobalHoliday"
      [ngClass]="getEventClass(item)"
      pTooltip="{{ item.title1 }} - {{ item.start | date : 'shortTime' | lowercase }} - {{ item.end | date : 'shortTime' | lowercase }}"
    >
      {{ item.title }}
    </small>

    <small
      *ngIf="!item.isHoliday && !item.isGlobalHoliday"
      [ngClass]="getEventClass(item)"
      pTooltip="{{ item.title1 }} - {{ item.start | date : 'shortTime' | lowercase }} - {{ item.end | date : 'shortTime' | lowercase }}"
    >
      {{ item.title }}
    </small>

    <small *ngIf="item.isGlobalHoliday" class="view-by-available-slots_event">
      {{ item.title }}
    </small>
  </div>
</ng-template>
